import {TranslateService} from '@ngx-translate/core';
import {Component, forwardRef, Inject, Injector, Input} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ModalResult} from "../model/common.model";
import {AlertService} from "../services/alert.service";
import {SessionService} from "../services/session.service";
import {ClientService} from "../services/client.service";
import {SecurityPerUser} from "../home/security/model/SecurityPerUser";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  templateUrl: 'DlgChangePasswordComponent.html',
})
export class DlgChangePasswordComponent {
  @Input() loading = false;

  currentPassword: string;
  newPassword: string;
  newPassword2: string;
  username: string;
  security = new SecurityPerUser();

  focusPassword = false;
  focusNewPassword = false;
  focusNewPassword2 = false;

  public barLabel: string = '';
  public myColors = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#00C853'];

  constructor(public activeModal: NgbActiveModal, private injector: Injector,
              @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
              @Inject(forwardRef(() => Router)) private router: Router,
              @Inject(forwardRef(() => SessionService)) private session: SessionService, private translate: TranslateService) {

    this.barLabel = this.translate.instant('PasswordStrength');

  }
  //
  // public accessiblePunches(): Employee[]{
  //   if (!Utils.isNullOrUndefined(this.punchPerEmploye)){
  //     return this.punchPerEmploye.accessiblePunches;
  //   }else{
  //     return Array<Employee>();
  //   }
  // }

  explainSecurityOfUser():SafeHtml{

    let res = '';
    if (this.security){
      res = this.security.explainPassword(this.translate);
    }
    /*
    if (this.data.securityPerEnterprise){
      if (this.data.securityPerEnterprise.passwordWillExpire){
        res += this.translate.instant('PasswordWillExpire',{passwordExpirationInDays:this.data.securityPerEnterprise.passwordExpirationInDays})
      }else{
        res += this.translate.instant('PasswordWillNotExpire')
      }
      res +=' ';
      if (this.data.securityPerEnterprise.failedLoginDeactivateAccount){
        res += this.translate.instant('AccountWillBeDeactivated',{nbMaxOfFailedLogin: this.data.securityPerEnterprise.nbMaxOfFailedLogin})
      }else{
        res += this.translate.instant('NoLimitForFailedLogin');
      }
      res += ' ';
      res += this.translate.instant('passwordRules',{minSizePwd: this.data.securityPerEnterprise.minSizePwd,
        minNbUpperCase:this.data.securityPerEnterprise.minNbUpperCase,minNbLowerCase:this.data.securityPerEnterprise.minNbLowerCase,
        minSpecialChar:this.data.securityPerEnterprise.minSpecialChar,minNumberDigit:this.data.securityPerEnterprise.minNumberDigit})
    }
     */

    return this.domSanitizer.bypassSecurityTrustHtml(res);
  }

  public populate( username: string, currentPwd: string, security: SecurityPerUser) {
    this.username = username;
    this.currentPassword = currentPwd;
    this.security = security;
  }

  isPwdValid(){
    if (this.newPassword!=null && this.newPassword2!=null){
      if (this.newPassword === this.newPassword2){
        return true;
      }
    }
    return false;
  }

  onUpdate() {
    this.loading = true;

    this.clientService.savePasswordForUser(this.username, this.currentPassword,this.newPassword).then(
      (res) => {
        if (res.success) {
          console.log('Information is ' + JSON.stringify(res.data, null, 1));
          this.activeModal.close(ModalResult.OK);
        } else {
          console.log('Error ' + res.description);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }

  onCancel() {
    this.activeModal.close(ModalResult.CANCEL);
  }


}
